import expenseRequestBlockService from '../../services/expenseRequestBlockService';

const state = {
  loading: false,
  settings: [],
  setting: null
};

const handleFailure = (dispatch, commit, e, router) => {
  commit('requestFailed');
  dispatch('common/handleServiceException', { e, router }, { root: true });
};

const actions = {
  async list({ dispatch, commit }, { router } = {}) {
    dispatch('alert/clear', {}, { root: true });
    commit('startRequest');
    try {
      const response = await expenseRequestBlockService.list();
      commit('setSettings', response.data || []);
    } catch (e) {
      handleFailure(dispatch, commit, e, router);
    }
  },
  async getOne({ dispatch, commit }, { id, router }) {
    dispatch('alert/clear', {}, { root: true });
    commit('setSetting', null);
    commit('startRequest');
    try {
      const response = await expenseRequestBlockService.getOne({ id });
      commit('setSetting', response.data || null);
    } catch (e) {
      handleFailure(dispatch, commit, e, router);
    }
  },
  async getByCompany({ dispatch }, { company, router }) {
    try {
      const response = await expenseRequestBlockService.getByCompany({ company });
      return response.data || [];
    } catch (e) {
      dispatch('common/handleServiceException', { e, router }, { root: true });
      return null;
    }
  },
  async postOne({ dispatch, commit }, { setting, router, redirectUrl }) {
    dispatch('alert/clear', {}, { root: true });
    commit('startRequest');
    try {
      await expenseRequestBlockService.postOne({ setting });
      commit('finishRequest');
      dispatch('alert/success', { showType: 'toast', position: 'bottom-end', title: '', text: 'Expense setting has been added.' }, { root: true });
      if (redirectUrl) router.push(redirectUrl);
    } catch (e) {
      handleFailure(dispatch, commit, e, router);
    }
  },
  async patchOne({ dispatch, commit }, { id, setting, router, redirectUrl }) {
    dispatch('alert/clear', {}, { root: true });
    commit('startRequest');
    try {
      await expenseRequestBlockService.patchOne({ id, setting });
      commit('finishRequest');
      dispatch('alert/success', { showType: 'toast', position: 'bottom-end', title: '', text: 'Expense setting has been updated.' }, { root: true });
      if (redirectUrl) router.push(redirectUrl);
    } catch (e) {
      handleFailure(dispatch, commit, e, router);
    }
  }
};

const mutations = {
  startRequest(state) {
    state.loading = true;
  },
  finishRequest(state) {
    state.loading = false;
  },
  requestFailed(state) {
    state.loading = false;
  },
  setSettings(state, settings) {
    state.settings = settings.map((setting, index) => ({
      ...setting,
      id: setting._id, // eslint-disable-line no-underscore-dangle
      rowNum: index + 1
    }));
    state.loading = false;
  },
  setSetting(state, setting) {
    state.setting = setting ? { ...setting, id: setting._id } : null; // eslint-disable-line no-underscore-dangle
    state.loading = false;
  }
};

export default { namespaced: true, state, actions, mutations };
